jQuery(function($){
	jQuery('.view-more-destinations-control').on('click', function() {

		$('.view-other-destinations').css('display','none');
		$('.other-destinations').css('display','block');
	});
});

jQuery(function($){

	$('.js-resorts-banner-splide').each(function() {

		var resortSplide = new Splide( '.splide-resorts', {
			type   : 'loop',
			pagination: true,
			perPage: 3,
			perMove: 1,
			speed: 800,
			breakpoints: {
				1199: {
					perPage: 2,
				},
				991: {
					perPage: 1,
				},
			}
		});

		resortSplide.mount();
	});

	$('.js-member-perks-splide').each(function() {
		
		var perkSplide = new Splide( '.splide-perks', {
			type   : 'loop',
			pagination: true,
			perPage: 3,
			perMove: 1,
			speed: 800,
			breakpoints: {
				1199: {
					perPage: 2,
				},
				991: {
					perPage: 1,
				},
			}
		});

		perkSplide.mount();
	});
});